import React from 'react'
import { useTranslation } from 'react-i18next'

import { ADMIN, MANAGER, REPORT } from '../../../../../../constants/selfAccounts'

import useDrawerFormClasses from '../../../../../../styles/common/drawerForms'

const PartnerRoleDescription = ({ role }) => {
  const { t } = useTranslation()
  const drawerFormClasses = useDrawerFormClasses()

  switch (role) {
    case ADMIN:
      return (
        <>
          <h3 className={drawerFormClasses.sectionTitle}>{t('Admin permissions:')}</h3>
          <p>
            Manage all campaigns <br />
            Manage team
          </p>
        </>
      )
    case MANAGER:
      return (
        <>
          <h3 className={drawerFormClasses.sectionTitle}>{t('Campaign Manager permissions:')}</h3>
          <p>
            Campaign Manager permissions: <br />
            Manage campaigns only
          </p>
        </>
      )
    case REPORT:
    default:
      return (
        <>
          <h3 className={drawerFormClasses.sectionTitle}>{t('Reporting Only permissions:')}</h3>
          <p>
            Reporting Only permissions: <br />
            Report on campaigns only
          </p>
        </>
      )
  }
}

export default PartnerRoleDescription
